<div class="row">
  <div class="col-xs-12" *ngIf="plan.vexatiousClauses">
    <div class="background3" style="padding: 10px">
      <!--<div class="big text-bold">{{'PARTECIPANT_LTI.DOCUMENTS.VEXATIOUS_CLAUSES' | translate}}</div>-->
      <div class="pointer" style="margin-top: 30px">
        <textarea class="form-control" name="name" rows="4" readonly></textarea>
      </div>
    </div>
  </div>

  <div class="col-xs-12" *ngIf="!plan.vexatiousClauses">
    <div class="background3" style="padding: 10px">
      <!--<div class="big text-bold">{{'PARTECIPANT_LTI.DOCUMENTS.VEXATIOUS_CLAUSES' | translate}}</div>-->
      <div class="pointer">
        <textarea class="form-control" name="name" rows="4" readonly></textarea>
      </div>
      <div class="" style="padding: 10px">
        <div class="col-xs-12 menuMobileItemGroup">
          <div class="bigYellowButton" (click)="plan.vexatiousClauses = true">
            {{ 'PARTECIPANT_LTI.DOCUMENTS.ACCEPT' | translate | uppercase }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
